'use strict';

const { queryFirst, hasClass } = require('../domUtil');

const HIDE_FILTERS_CLASS = 'hidden-filters';
const REFINEMENT_BAR_SELECTOR = '.refinement-bar';
const FILTERS_CONTAINER_SELECTOR = '.search-results-container';

/**
 * When filters are collapsed on desktop, the sidebar stays in the layout
 * (max-width/overflow) so it remains in the tab order. Mark it inert so
 * keyboard users skip the ~20+ hidden refinement controls.
 */
function syncCollapsedFiltersA11y() {
    const refinementBar = queryFirst(REFINEMENT_BAR_SELECTOR);
    const filtersContainer = queryFirst(FILTERS_CONTAINER_SELECTOR);

    if (!refinementBar || !filtersContainer) {
        return;
    }

    const collapsed = hasClass(filtersContainer, HIDE_FILTERS_CLASS);

    if (collapsed) {
        refinementBar.setAttribute('inert', '');
        refinementBar.setAttribute('aria-hidden', 'true');
        return;
    }

    refinementBar.removeAttribute('inert');
    refinementBar.removeAttribute('aria-hidden');
}

module.exports = {
    syncCollapsedFiltersA11y
};
